import { render, staticRenderFns } from "./actionGenerateREM.vue?vue&type=template&id=e18f01ea"
import script from "./actionGenerateREM.vue?vue&type=script&lang=js"
export * from "./actionGenerateREM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports